import { MenuItem } from '@/types/fnb'
import { requestWithRetry } from '../axios'

export const postOrder = async (
  instance_uid: string,
  basket: MenuItem[],
  location_id?: string | null,
) => {
  const items = basket.map(({ item_id, name, quantity, price }) => ({
    item_id,
    name,
    quantity,
    price,
  }))

  const payload: Record<string, unknown> = {
    instance_uid,
    items,
  }
  // Only consumed by the backend at order creation (create_pos_order). Sent for
  // `options` pickup mode; omitted otherwise so the integration default /
  // routing applies.
  if (location_id) payload.location_id = location_id

  try {
    return await requestWithRetry(`fnb/order`, 'post', payload)
  } catch (error: any) {
    // Surface the failure so the store's addItem catch can revert cleanly and
    // show the real reason, instead of returning junk that breaks the order
    // flow (a missing `payable` would silently hide the basket/checkout).
    console.log('postOrder Error:', error.response?.data)
    const detail =
      error.response?.data?.detail ||
      error.response?.data?.message ||
      'Could not create your order'
    throw new Error(detail)
  }
}
